import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import ContactCardDetails from 'go/components/organization/contact/pointOfContactCardDetails';

export class DynamicContactsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contacts: [],
    };
  }

  UNSAFE_componentWillMount() {
    let contacts;
    if (this.props.context.organization) {
      contacts = this.props.context.organization.organizationContacts;
      this.generateLists(contacts);
    }
  }

  generateLists(contacts) {
    let newContacts = [];
    if (contacts !== undefined) {
      contacts.forEach((contact) => {
        newContacts.push(contact.organizationContact.contact);
      });
    }
    this.setState({
      contacts: newContacts,
    });
  }

  displayPhoneNumber(areaCode, phoneNumber) {
    let value = '';
    if (areaCode) {
      value += '(' + areaCode;
    }
    if (phoneNumber) {
      value += ') ' + phoneNumber.substr(0, 3);
      if (phoneNumber.length > 3) {
        value += '-' + phoneNumber.substr(3, 7);
      }
    }
    return value;
  }

  renderContacts(contacts) {
    let aorTitleFlag = false;
    let pocTitleFlag = false;
    return (
      <React.Fragment>
        {_.map(contacts, (contact, index) => {
          if (contacts[index].electronicPoc === true) {
            let renderAor = this.renderContact(
              contact,
              'aor',
              index,
              aorTitleFlag,
              aorTitleFlag
            );
            aorTitleFlag = true;
            return renderAor;
          } else {
            let renderPoc = this.renderContact(
              contact,
              'poc',
              index,
              aorTitleFlag,
              pocTitleFlag
            );
            pocTitleFlag = true;
            return renderPoc;
          }
        })}
      </React.Fragment>
    );
  }

  renderContact(contact, type, index, aorTitleFlag, pocTitleFlag) {
    return (
      <div key={type + index} id={type + index}>
        {type === 'aor' && !aorTitleFlag ? <h5>{this.props.apocTitle}</h5> : null}
        {type === 'poc' && !pocTitleFlag ? <h5>{this.props.pocTitle}</h5> : null}
        <ContactCardDetails
          contact={contact}
          displayPhoneNumber={this.displayPhoneNumber}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="poc-cards">
        {this.state.contacts <= 0
          ? 'No Contact Information'
          : this.renderContacts(this.state.contacts)}
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  const {context} = state.dynamicComponent;
  return {
    context: context,
  };
};

export default connect(mapStateToProps, null)(connectDynamic(DynamicContactsCard));
